import { render, staticRenderFns } from "./confirm-document.vue?vue&type=template&id=67c93898&scoped=true&"
import script from "./confirm-document.vue?vue&type=script&lang=js&"
export * from "./confirm-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c93898",
  null
  
)

export default component.exports